import { useMemo, useState, useCallback } from 'react';
import { QuestionViewPropsFor } from '@/components/question/view/types';
import { QuestionTypeEnum } from '@/models/Question';

export type FlashcardCorrection = 'false' | 'true';

export type FlashcardAnswerOption = {
  value: FlashcardCorrection;
};

export function useFlashcardAnswer(
  props: QuestionViewPropsFor<QuestionTypeEnum.FLASHCARD>,
) {
  const { value, mode } = props;
  const onChange = props.mode === 'answering' ? props.onChange : undefined;
  const disabled = mode !== 'answering';

  const [showBack, setShowBack] = useState(false);

  const options = useMemo<FlashcardAnswerOption[]>(
    () => [{ value: 'false' }, { value: 'true' }],
    [],
  );

  const selectedValues = value == null ? '' : String(value);

  const handleChange = useCallback(
    (next: string) => {
      onChange?.(next === '' ? null : next);
    },
    [onChange],
  );

  const revealBack = useCallback(() => {
    setShowBack(true);
  }, []);

  return {
    options,
    selectedValues,
    handleChange,
    disabled,
    showBack,
    revealBack,
    mode,
  };
}
